import { render, staticRenderFns } from "./trainingReportSingleDetail.vue?vue&type=template&id=38444b86&scoped=true"
import script from "./trainingReportSingleDetail.vue?vue&type=script&lang=js"
export * from "./trainingReportSingleDetail.vue?vue&type=script&lang=js"
import style0 from "./trainingReportSingleDetail.vue?vue&type=style&index=0&id=38444b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38444b86",
  null
  
)

export default component.exports